import { frenchHolidays } from "./frenshHolidays";

/**
 * Add N business days (Mon–Fri, skipping frenchHolidays) to a date in place.
 */
function addBusinessDays(date: Date, days: number): void {
  while (days > 0) {
    date.setDate(date.getDate() + 1);
    const wd = date.getDay(); // 0=Sun,6=Sat
    const iso = date.toISOString().slice(0, 10);
    if (wd !== 0 && wd !== 6 && !frenchHolidays.has(iso)) {
      days--;
    }
  }
}

/**
 * Calculate your “date limite de collecte” logic.
 * @param ddLike – if true, use 10 days; else 2 or 3 based on afternoon/weekend.
 */
export function calculateCollecteDate(ddLike = true): Date {
  const date = new Date();

  const hour = date.getHours();
  const wd = date.getDay(); // 0=Sun,6=Sat
  let delta: number;
  if (ddLike) {
    delta = 10;
  } else {
    // if after noon or weekend → 3 days, else 2
    delta = hour > 12 || wd === 0 || wd === 6 ? 3 : 2;
  }

  // 1. Walk delta business days, but count holidays hit
  let holidayCount = 0;
  for (let i = 0; i < delta; i++) {
    const iso = date.toISOString().slice(0, 10);
    if (frenchHolidays.has(iso)) {
      holidayCount++;
    }
    addBusinessDays(date, 1);
  }

  // 2. If we land on weekend/holiday, advance to next business day
  while (true) {
    const iso = date.toISOString().slice(0, 10);
    const d = date.getDay();
    if (d === 0 || d === 6 || frenchHolidays.has(iso)) {
      addBusinessDays(date, 1);
    } else break;
  }

  // 3. Compensate extra holiday days
  if (holidayCount > 0) {
    addBusinessDays(date, holidayCount);
  }

  // 4. Again ensure we end on business day
  while (true) {
    const iso = date.toISOString().slice(0, 10);
    const d = date.getDay();
    if (d === 0 || d === 6 || frenchHolidays.has(iso)) {
      addBusinessDays(date, 1);
    } else break;
  }

  return date;
}
